/**
 * Determine whether the token should use the alternate orientation
 * @param {Token} token
 */
export function isAltOrientation(token) {
	foundry.utils.logCompatibilityWarning(
		"[hex-size-support api] isAltOrientation is deprecated with no replacement",
		{ since: 13, until: 14, once: true }
	);
	return !!(token.document.hexagonalShape & 1);
}
